import cashBookInstance from '../../cashBook/instance'

const cancelTransaction = (paymentTransactionId, data) => {
	return cashBookInstance.put(`/cash-book/records/${paymentTransactionId}/cancel`, data)
}

export default cancelTransaction
